export var PhotoCaptureMessageType;
(function (PhotoCaptureMessageType) {
    PhotoCaptureMessageType["ERROR"] = "ERROR";
    PhotoCaptureMessageType["SUCCESS"] = "SUCCESS";
    PhotoCaptureMessageType["INVALID"] = "INVALID";
    PhotoCaptureMessageType["CLOSED"] = "CLOSED";
    PhotoCaptureMessageType["LINK_EXPIRED"] = "LINK_EXPIRED";
    PhotoCaptureMessageType["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    PhotoCaptureMessageType["OPENED"] = "OPENED";
})(PhotoCaptureMessageType || (PhotoCaptureMessageType = {}));
//# sourceMappingURL=PhotoCaptureMessageType.js.map